import React, { useEffect } from 'react';

export default function AdSenseInArticle() {
  useEffect(() => {
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.error('AdSense error', err);
    }
  }, []);

  return (
    <div className="my-8 w-full overflow-hidden flex justify-center">
      <ins
        className="adsbygoogle"
        style={{ display: 'block', textAlign: 'center' }}
        data-ad-layout="in-article"
        data-ad-format="fluid"
        data-ad-client="ca-pub-3727360641177439"
        data-ad-slot="5586585359"
      ></ins>
    </div>
  );
}
